import { __decorate, __metadata } from "tslib";
import { MediaAssetItem } from '@common/media/shared';
import { AppRequest } from '@core/shared/app-request';
import { Expose, Model, ModelId, Type } from '@core/shared/model';
import { AppRequestMethod } from '@core/shared/request';
let GenerateCloudinaryTransformationsRequest = /*#__PURE__*/(() => {
  let GenerateCloudinaryTransformationsRequest = class GenerateCloudinaryTransformationsRequest extends Model {};
  __decorate([Expose(), Type(() => MediaAssetItem), __metadata("design:type", MediaAssetItem)], GenerateCloudinaryTransformationsRequest.prototype, "item", void 0);
  __decorate([Expose(), __metadata("design:type", Array)], GenerateCloudinaryTransformationsRequest.prototype, "transformations", void 0);
  GenerateCloudinaryTransformationsRequest = __decorate([AppRequest('admin/cloudinary', 'generate-transformations', {
    httpMethod: AppRequestMethod.POST
  }), ModelId("GenerateCloudinaryTransformationsRequest") // auto-generated by generate-model-ids
  ], GenerateCloudinaryTransformationsRequest);
  return GenerateCloudinaryTransformationsRequest;
})();
export { GenerateCloudinaryTransformationsRequest };